// extracted by mini-css-extract-plugin
export default {"loading_container":"List_loading_container__BbO02","message_list":"List_message_list__ERlny","loading":"List_loading__Tf9Re"};